document.addEventListener('easysearch_loaded', function () {
  const easysearchWidget = document.querySelectorAll('.easysearch-embed-widget-main');
  easysearchWidget.forEach((widget) => {
    const buttonHolder = widget.querySelector('.easysearch-btn-holder');
    const button = widget.querySelector('a.easysearch-btn-search');
    const selects = widget.querySelectorAll('select');

    selects.forEach(addLabelForSelect);
    replaceButtonContent(button);

    if (widget.closest('easysearch-modal') || widget.closest('.product-easysearh')) {
      insertButton(buttonHolder);
    }
  });

  if (window.easysearch && window.easysearch.curIndex) {
    const localValue = localStorage.getItem('custom:easysearch-index');
    if (localValue && typeof localValue === 'string') {
      const values = localValue.split(',');
      selectEasySearchValues(values);
    }
  }
});

function addLabelForSelect(select) {
  if (select instanceof HTMLSelectElement && select.labels.length === 0) {
    const hiddenOption = [...select.options].find((option) => option.hasAttribute('hidden'));
    const label = hiddenOption ? hiddenOption.textContent : select.innerText.split('\n')[0];
    const labelNormalized = label.replace('Select', '').trim();
    const labelTag = document.createElement('span');
    labelTag.textContent = labelNormalized;
    select.before(labelTag);
  }
}

function replaceButtonContent(button) {
  if (button instanceof HTMLElement) {
    const { buttonLabel, buttonLabelModal } = window.easy_search_texts;
    if (buttonLabel) {
      const isModal = !!button.closest('easysearch-modal');
      button.innerHTML = '';

      const div = document.createElement('div');
      div.classList.add('easysearch-btn__wrapper');
      const span = document.createElement('span');
      span.textContent = isModal ? buttonLabelModal : buttonLabel;
      div.appendChild(span);

      if (!isModal) {
        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6.06086 8.33334L2.66667 11.7039L3.63624 12.6667L8 8.33334L3.63624 4L2.66667 4.96282L6.06086 8.33334Z" fill="#212121"></path><path d="M11.3944 8.33334L8.00016 11.7039L8.96973 12.6667L13.3335 8.33334L8.96973 4L8.00016 4.96282L11.3944 8.33334Z" fill="#212121"></path></svg>`;
        const svgNode = new DOMParser().parseFromString(svg, 'image/svg+xml').documentElement;
        div.appendChild(svgNode);
      }

      button.append(div);
    }
  }
}

function insertButton(wrapper) {
  const button = document.createElement('easysearch-reset');
  button.textContent = 'CLEAR';
  button.classList.add('easysearch-reset', 'easysearch-btn-reset');
  if (wrapper && wrapper instanceof HTMLElement) {
    wrapper.prepend(button);
  }
}

function selectEasySearchValues(values) {
  const holders = document.querySelectorAll(
    '.easysearch-modal .easysearch-holder, .product-easysearh .easysearch-holder',
  );

  holders.forEach((holder) => {
    if (!holder || !window.easysearch) return;
    easysearch.searchFormFillAllSelects(holder, values);
  });
}
